export default __webpack_public_path__ + "static/media/bgEllipse.2ca3fe0f.svg";